module.exports = __webpack_public_path__ + "assets/img/vtuber-ads3.35e9e3dd.png";